export default "__VITE_ASSET__C5qJSoLP__"